<script>
	import { onMount, onDestroy } from 'svelte'

    import SubtaskStore from './stores/subtasks'
    import AgentStore from './stores/agents'
    import ProjectStore from './stores/projects'
    import { currentUser } from './stores/current_user'

	import { FirebaseResults } from './middleware/database'
    import { SubTasks } from './middleware/database/subtasks'
    import { Agents } from './middleware/database/agents'
    import { Projects } from './middleware/database/projects'

	import NavBar from './components/NavBar.svelte'
    import Router from './routes/Router.svelte'

    let unsubscribeSubtasks = null
    let unsubscribeAgents = null
    let unsubscribeProjects = null

    $: if ($currentUser) {
         unsubscribeSubtasks = SubTasks.findAll().onSnapshot(docs => {
            let subtasks = FirebaseResults.map(docs)
                .reduce((obj,item) => {
                    return { ...obj, [item['id']]: item,};
                }, {})
            SubtaskStore.set(subtasks)
        }, err => {
            console.log('Error fetching subtasks')
        })
        unsubscribeAgents = Agents.findAll().onSnapshot(docs => {
            let agents = FirebaseResults.map(docs)
                .reduce((obj,item) => {
                    return { ...obj, [item['id']]: item,};
                }, {'--NO-AGENT--': { id: null, name: '--No-Agent--'}})
            AgentStore.set(agents)
        }, err => {
            console.log('Error fetching agents')
        })
        unsubscribeProjects = Projects.findAll().onSnapshot(docs => {
            //projects['--NO-PROJECT--'] = { id: null, name: '--No-Project--' }
            let projects = FirebaseResults.map(docs)
                    .reduce((obj,item) => {
                        return { ...obj, [item['id']]: item,};
                    }, {'--NO-PROJECT--': {id: null, name: '--No-Project--'}})
            ProjectStore.set(projects)
        }, err => {
            console.log('Error fetching projects')
        })

    } else {
        if (unsubscribeSubtasks)
            unsubscribeSubtasks()
        if (unsubscribeAgents)
            unsubscribeAgents()
        if (unsubscribeProjects)
            unsubscribeProjects()
    }

    onDestroy(() => {
        if (unsubscribeSubtasks)
            unsubscribeSubtasks()
        if (unsubscribeAgents)
            unsubscribeAgents()
        if (unsubscribeProjects)
            unsubscribeProjects()
    })
</script>

<NavBar/>
<Router />

